import CompanionMaterialItem from '@/models/CompanionMaterialItem';
import CompanionMaterialItemConstants from '../CompanionMaterialItemConstants';
import ICompanionMaterialConversionHandler from './ICompanionMaterialConversionHandler';

class ProtractorCompanionMaterialConversionHandler implements ICompanionMaterialConversionHandler {
  execute(companionMaterialItem: CompanionMaterialItem): Map<string, unknown> {
    const map: Map<string, unknown> = new Map();

    if (companionMaterialItem && companionMaterialItem.name === CompanionMaterialItemConstants.PROTRACTOR) {
      map.set('protractor', true);
    }

    return map;
  }
}

export default ProtractorCompanionMaterialConversionHandler;
